import { css, jsx } from '@emotion/core';
import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import { requestStaticContent } from '@/src/cms/utils';
import { bp } from '@/styles';

function JoinACommittee(props) {
  return (
    <ContentPage
      {...props}
      bodyStyle={css`
        > div > ul {
          display: block;
          list-style-position: inside;
          @media ${bp.sm} {
            margin-left: 32px;
          }
          > li {
            list-style-type: disc;
          }
        }
      `}
    />
  );
}

export async function getStaticProps() {
  const sitepageid = 392;
  const pagedata = await requestStaticContent(sitepageid);
  return { props: { sitepageid, pagedata } };
}

export default JoinACommittee;
